module.exports = __webpack_public_path__ + "media/images/icon/plus-48fbd7610740b237beb0c05c75be31d2.svg";